import React from 'react'
import './projectcard.css'

function ProjectCard({project}) {
    return (
        <div className='project-card'>
            <div className='project-info'>
                <label className='project-title'>{project.title}</label>
                <div className='project-links'>
                    {project.demo&&(
                        <a className='project-link' href={project.demo} target="_blank">
                            <div className='link-button'>
                                <img src='/globe.png' className='globe-icon'></img>Demo
                            </div>
                    </a>)}
                    {project.github&&(
                        <a className='project-link' href={project.github} target="_blank">
                            <div className='link-button'>
                            <i class="devicon-github-original colored"></i>GitHub
                            </div>
                    </a>)}
                    {project.youtube&&(
                        <a className='project-link' href={project.youtube} target="_blank">
                            <div className='link-button'>
                                <img src='/globe.png' className='globe-icon'></img>Video
                            </div>
                    </a>)}
                </div>
                <p className='project-desc'>{project.about}</p>
                <div className='project-tags'>
                    {project.tags.map((tag)=> {
                        return (
                            <label className='tag'>{tag}</label>
                        )
                    })}
                </div>
            </div>
            <img src={project.image} className='project-photo'></img> 
        </div>
    )
}

export default ProjectCard
